import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Tooltip, Stack, Typography, Link, Box } from '@mui/material';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// routes
import { PATH_AUTH } from '../../routes/paths';
// layouts
import LoginLayout from '../../layouts/login';
//
import AuthLoginForm from './AuthLoginForm';
import GoogleAuth from '../../pages/auth/GoogleAuth';

// ----------------------------------------------------------------------

export default function Login() {
  const { method } = useAuthContext();

  return (
    <LoginLayout>
      <Typography
        sx={{
          mt: 3,
          mb: 3,
          fontSize: '22px',
          maxWidth: 430,
          fontWeight: 400,
          textAlign: 'center',
          color: 'grey.500',
        }}
      >
        {' '}
      </Typography>
      <Stack
        spacing={2}
        alignItems="center"
        width="100%"
        sx={{ px: 2, mb: 5, position: 'relative', '& form': { width: '100%' } }}
      >
        <AuthLoginForm />
        <br />
        <GoogleAuth isLogin />
        <br />
        <Stack direction="row" spacing={0.5}>
          <Typography color="grey.500" variant="body2">
            Don&apos;t have an account yet ?
          </Typography>
          <Link component={RouterLink} to={PATH_AUTH.register} variant="subtitle2">
            Sign Up
          </Link>
        </Stack>
      </Stack>
    </LoginLayout>
  );
}
